export const LIST_MONTHS = [
  {
    title: 'constantsGlobal.dates.january',
    value: '01'
  },
  {
    title: 'constantsGlobal.dates.february',
    value: '02'
  },
  {
    title: 'constantsGlobal.dates.march',
    value: '03'
  },
  {
    title: 'constantsGlobal.dates.april',
    value: '04'
  },
  {
    title: 'constantsGlobal.dates.may',
    value: '05'
  },
  {
    title: 'constantsGlobal.dates.june',
    value: '06'
  },
  {
    title: 'constantsGlobal.dates.july',
    value: '07'
  },
  {
    title: 'constantsGlobal.dates.august',
    value: '08'
  },
  {
    title: 'constantsGlobal.dates.september',
    value: '09'
  },
  {
    title: 'constantsGlobal.dates.october',
    value: '10'
  },
  {
    title: 'constantsGlobal.dates.november',
    value: '11'
  },
  {
    title: 'constantsGlobal.dates.december',
    value: '12'
  }
];
